import { render, staticRenderFns } from "./AddRedeemCodeDialog.vue?vue&type=template&id=b37a5c2e"
import script from "./AddRedeemCodeDialog.vue?vue&type=script&lang=js"
export * from "./AddRedeemCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports